const envType = process.env.REACT_APP_ENV; // Environment type from environment variables
const isProd = envType === 'PROD';

export const integrationKey = '43d2dd47-203f-4c78-9d32-0504a84e245f';
export const scriptLink = isProd
  ? 'https://js.docusign.com/bundle.js'
  : 'https://js-d.docusign.com/bundle.js';
